import { useEffect, useState } from 'react';
import Head from "next/head";
import Script from 'next/script'
import {configuratorHost } from '@/lib/utils.js'


export default function ProductPageConfigurator({product, sku_part_query, always_show_description}) {
 const [configHTML, setConfigHTML] = useState('');
  const show_desc = always_show_description ? true : false  
 useEffect(() => {
 if (typeof window != 'undefined') {
   let queryStr = `?always_show_description=${show_desc}`
   if (sku_part_query) {
     queryStr += `&sku_parts=${sku_part_query}`
   }
 
  fetch(`/lex-api/configurator/${product.id}${queryStr}`, 
    ).then(r => {
      return r.text() })
     .then(html => { 
        setConfigHTML(html)
     })
   }
  }, [])

 return (
   <>
     <Head>
       <link key={'configurator-styles'} rel='stylesheet' href={`${configuratorHost()}/configurator_styles.css`}/>
       
     </Head>
<Script key={'configurator-js'} src={`${configuratorHost()}/configurator_app.js`} 
       strategy='beforeInteractive'> </Script>
   <div id='lexcms-product-configurator-container' className='lexcms-product-section-container'  > 
     <h3 className="lexcms-product-section-heading"> Configure </h3>
     {configHTML &&
     <div id='lex-cms-configurator-app' dangerouslySetInnerHTML={{ __html: configHTML }} />
     }
   </div>
   </>
   )
}
